<template>
  <div class="container">
    <div class="panel">
      <div class="panel-container">
        <div class="panel-logo">
          <img src="../public/web-farm-logo.png" />
        </div>
        <div class="panel-form">
          <div class="title">
            <h1>Faça seu login</h1>
          </div>
          <AppForm
            ref="form"
            :rules="rules"
            :values="loginData"
            v-slot:default="{ formErrors }"
          >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.username" label="Usuário">
                  <InputText
                    v-model="loginData.username"
                    type="text"
                    @blur="$refs.form.validate('username')"
                    @keyup.enter="login()"
                  />
                </AppFormItem>
              </div>

              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.password" label="Senha">
                  <span class="p-input-icon-right">
                    <InputText
                      v-model="loginData.password"
                      :type="showPassword ? 'text' : 'password'"
                      @blur="$refs.form.validate('password')"
                      @keyup.enter="login()"
                    />
                    <i
                      :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                      @click="showPassword = !showPassword"
                    />
                  </span>
                </AppFormItem>
              </div>
            </div>
          </AppForm>
          <div class="p-grid">
            <div class="p-col-12">
              <AppButton
                label="Continuar"
                style="width: 100%"
                :loading="loading"
                @click="login()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cover"></div>
  </div>
  <Toast position="top-center"></Toast>

  <AccountWarningDefaulting
    v-if="statusId === 3"
    v-model:visible="showAccountWarning"
    :account="account"
  />
  <AccountWarningCanceled
    v-if="statusId === 4"
    v-model:visible="showAccountWarning"
    :account="account"
  />
</template>

<script>
import { AuthApi } from './services/api/auth';
import AccountWarningDefaulting from './components/AccountWarningDefaulting';
import AccountWarningCanceled from './components/AccountWarningCanceled';
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  components: {
    AccountWarningDefaulting,
    AccountWarningCanceled,
  },
  data() {
    return {
      loginData: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: 'Informe o nome do usuário.' }],
        password: [{ required: true, message: 'Informe a senha.' }],
      },
      statusId: null,
      showAccountWarning: false,
      showPassword: false,
      loading: false,
    };
  },

  methods: {
    ...mapActions('app', ['setSession', 'setShowAccountWarning']),
    async recaptcha() {
      if (process.env.NODE_ENV !== 'production') {
        return undefined;
      }
      await this.$recaptchaLoaded();
      return this.$recaptcha('login');
    },
    async login() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.loading = true;
        const token = await this.recaptcha();
        const body = {
          ...this.loginData,
          token,
          accountId: this.$route.query.accountId || undefined,
        };

        const { accessToken, user, permissions } = await AuthApi.login(body);

        this.setSession({ accessToken, user, permissions });
        this.setShowAccountWarning(user);
        if (user.roleId === 1 && !user.account) {
          this.$router.push({ name: 'account.list' });
        } else if (user?.account?.isVet) {
          this.$router.push({ name: 'service.list' });
        } else {
          this.$router.push({ name: 'home' });
        }
      } catch (error) {
        console.log(error);
        if (
          error?.response?.data?.code === 'Unauthorized' &&
          (error?.response?.data?.error?.account?.statusId === 3 ||
            error?.response?.data?.error?.account?.statusId === 4)
        ) {
          this.showAccountWarning = true;
          this.statusId = error?.response?.data?.error?.account?.statusId;
          return;
        }

        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail: 'Login ou senha incorreta, tente novamente!',
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #396df4;
  overflow: hidden;
}

.panel {
  flex: 0 0 400px;
  background: white;
  padding: 0 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.cover {
  flex: 1;
  background: url('../public/login-bg.jpg') no-repeat center center;
  background-size: cover;
  opacity: 0.5;
  overflow: hidden;
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
}

.title {
  text-align: center;
  margin-top: 40px;
}

.panel-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.panel-logo {
  flex: 0 0 200px;
  top: 0;
  position: absolute;
}

.panel-logo img {
  width: 200px;
}

.panel-form {
  align-items: center;
  justify-content: center;
}

@media (max-width: 450px) {
  .container {
    width: 100%;
    height: 100vh;
    background-color: #396df4;
  }

  .panel {
    flex: 0 0 100%;
    padding: 0 30px;
  }

  .cover {
    display: none;
  }
}
</style>